import React from "react";
import { FaXTwitter, FaInstagram, FaFacebookF, FaLinkedinIn } from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="bg-gray-50 md:py-24 py-12 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-16">
        {/* Logo Section */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
        <div className="mobile-logo"> 
          <img className="w-auto h-12 md:h-16" src="img/logo.png" alt="Logo" /> 
        </div>
          
          <p className="text-gray-600 text-sm md:text-base mt-4">
            © Turning Ideas Ventures. All rights reserved.
          </p>
        </div>

        {/* Navigation Links */}
        <nav className="text-center md:text-left hidden md:block">
          <ul className="space-y-2 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-6">
            <li>
              <a href="/indian" className="text-gray-600 hover:text-blue-600 font-bold transition-colors duration-200 block">Accelerate</a>
            </li>
            <li>
              <a href="/about" className="text-gray-600 hover:text-blue-600 font-bold transition-colors duration-200 block">About us</a>
            </li>
            <li>
              <a href="/global" className="text-gray-600 hover:text-blue-600 font-bold transition-colors duration-200 block">Scale</a>
            </li>
            <li>
              <a href="/" className="text-gray-600 hover:text-blue-600 font-bold transition-colors duration-200 block">Terms</a>
            </li>
            <li>
              <a href="/enterprise" className="text-gray-600 hover:text-blue-600 font-bold transition-colors duration-200 block">Co-create</a>
            </li>
            <li>
              <a href="/" className="text-gray-600 hover:text-blue-600 font-bold transition-colors duration-200 block">Privacy Policy</a>
            </li>
          </ul>
        </nav>

        {/* Contact and Social Links */}
        <div className="text-center md:text-left">
          <div className="mb-4">
            <p className="font-bold text-gray-900 text-md md:text-lg">turningideas.com</p>
            <p className="text-gray-500 text-sm md:text-md mt-1">
              Want a growth consultation session to scale your startup or business?
            </p>
          </div>
          {/* Social Icons - Uncomment to use */}
          <div className="flex space-x-2 justify-center md:justify-start mt-4 text-blue-900">
            <a href="https://x.com/turningidea" target="_blank" rel="noreferrer"  className="hover:opacity-75 transition-opacity duration-200 bg-blue-600 rounded-full p-2 md:p-1 lg:p-2">
              <FaXTwitter className="text-lg md:text-sm lg:text-lg cursor-pointer text-white" />
            </a>
            <a href="https://www.instagram.com/turningideas" target="_blank" rel="noreferrer"  className="hover:opacity-75 transition-opacity duration-200 bg-blue-600 rounded-full p-2 md:p-1 lg:p-2">
              <FaInstagram className="text-lg md:text-sm lg:text-lg cursor-pointer text-white" />
            </a>
            <a href="https://www.facebook.com/turnideas" target="_blank" rel="noreferrer"  className="hover:opacity-75 transition-opacity duration-200 bg-blue-600 rounded-full p-2 md:p-1 lg:p-2">
              <FaFacebookF className="text-lg md:text-sm lg:text-lg cursor-pointer text-white" />
            </a>
            <a href="https://www.linkedin.com/company/turningideas-solutions" rel="noreferrer"  target="_blank" className="hover:opacity-75 transition-opacity duration-200 bg-blue-600 rounded-full p-2 md:p-1 lg:p-2">
              <FaLinkedinIn className="text-lg md:text-sm lg:text-lg cursor-pointer text-white" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
